import { LOYALTY_VIC_DOUBLE_POINTS_CAMPAIGN } from 'loyalty/constants/loyaltyEarn'

function getLoyaltyVictoriaBonusCampaignEarnKey(
  propertyState: string | undefined,
  propertyCountryCode: string | undefined,
): string | undefined {
  const now = new Date()
  if (now < new Date(LOYALTY_VIC_DOUBLE_POINTS_CAMPAIGN.startDate) || now > new Date(LOYALTY_VIC_DOUBLE_POINTS_CAMPAIGN.endDate)) {
    return undefined
  }
  if (propertyCountryCode !== 'AU') return undefined
  if (!propertyState) return undefined
  const upper = propertyState.toUpperCase()
  if (upper === 'VIC' || upper === 'VICTORIA') {
    return LOYALTY_VIC_DOUBLE_POINTS_CAMPAIGN.earnKey
  }
  return undefined
}

export default getLoyaltyVictoriaBonusCampaignEarnKey
